import { OptimizationOverview } from "@web-app/types";

import { formatCurrency } from "../utils";

type OverviewCardsProps = {
  overview?: OptimizationOverview;
};

const Card = ({ label, value }: { label: string; value: string }) => (
  <div className="rounded-lg border border-gray-200 p-4">
    <p className="text-sm text-gray-500">{label}</p>
    <p className="mt-1 text-xl font-semibold text-gray-900">{value}</p>
  </div>
);

export default function OverviewCards({ overview }: OverviewCardsProps) {
  const data = overview ?? {
    avgCostPerDrop: 0,
    totalCost: 0,
    totalOrdersSent: 0,
  };

  return (
    <div>
      <h3 className="text-base font-semibold text-gray-900">
        Overall Information
      </h3>
      <p className="mt-1 text-sm text-gray-500">
        Calculations are based on total orders, total cost, and average cost per
        drop to project percentage savings accurately
      </p>
      <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
        <Card label="Total Orders Sent" value={String(data.totalOrdersSent)} />
        <Card label="Total Cost" value={formatCurrency(data.totalCost)} />
        <Card
          label="Avg Cost per Drop"
          value={formatCurrency(data.avgCostPerDrop)}
        />
      </div>
    </div>
  );
}
